import { render, staticRenderFns } from "./anchor-info-usercenter.vue?vue&type=template&id=d7d55b16&scoped=true"
import script from "./anchor-info-usercenter.vue?vue&type=script&lang=js"
export * from "./anchor-info-usercenter.vue?vue&type=script&lang=js"
import style0 from "./anchor-info-usercenter.vue?vue&type=style&index=0&id=d7d55b16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7d55b16",
  null
  
)

export default component.exports